import React, { useCallback, useState } from 'react'
import { Typography } from '@mui/material'
import { blockUser, blockTenantUser } from '../api'
import { translate } from '../i18n'
import { DialogPopup } from '../components'
import { UserBlockPopupProps } from './UserBlockPopup.types'

export default function UserBlockPopup({
    tenantId,
    user,
    onCompleted,
    onCancelled,
    onError,
}: UserBlockPopupProps) {
    const [submitting, setSubmitting] = useState(false)

    const blockPromise = useCallback((): Promise<void> => {
        if (tenantId) {
            return blockTenantUser(tenantId, user.id)
        }
        return blockUser(user.id)
    }, [user, tenantId])

    const onConfirm = useCallback(() => {
        setSubmitting(true)
        blockPromise()
            .then(() => {
                setSubmitting(false)
                onCompleted()
            })
            .catch((error) => {
                setSubmitting(false)
                onError(error.message)
            })
    }, [blockPromise, onCompleted, onError])

    return (
        <DialogPopup
            open
            variant="warning"
            title={translate('users.block.title') as string}
            disableEscapeKeyDown={submitting}
            disableBackdropClick={submitting}
            disable={submitting}
            closeText={translate('buttons.cancel') as string}
            onClose={onCancelled}
            button={{
                text: translate('buttons.block'),
                onClick: onConfirm,
                disabled: submitting,
            }}
        >
            <Typography variant="body2">
                {translate('users.block.description', {
                    first_name: user.first_name,
                })}
            </Typography>
        </DialogPopup>
    )
}
